<h1 mat-dialog-title>{{header}}</h1>
<mat-dialog-content style="max-width: 600px;">{{message}}</mat-dialog-content>
<mat-dialog-actions style="justify-content: end;">
    <button mat-stroked-button (click)="onNoClick()" >Cancel</button>
    <button mat-button (click)="onYesClick()" #create color="buttonError">Delete</button>
</mat-dialog-actions>